import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import teamService from '../services/teamService';

const teamCollectionName = 'teams';

export const useTeam = () => {
  return useQuery({
    queryKey: [teamCollectionName],
    queryFn: () => teamService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddTeam = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: teamService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [teamCollectionName] });
    },
  });
};

export const useEditTeam = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: teamService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [teamCollectionName] });
    },
  });
};

export const useDeleteTeam = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: teamService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [teamCollectionName] });
    },
  });
};

export const useTeamIdByName = (teamName) => {
  return useQuery({
    queryKey: [teamCollectionName, teamName],
    queryFn: () => teamService.getIdByName(teamName),
    enabled: !!teamName,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useTeamNameById = (teamId) => {
  return useQuery({
    queryKey: [teamCollectionName, teamId],
    queryFn: () => teamService.getNameById(teamId),
    enabled: !!teamId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useDivisionTeams = (divisionId) => {
  return useQuery({
    queryKey: [teamCollectionName, divisionId],
    queryFn: () => teamService.getDivisionTeams(divisionId),
    enabled: !!divisionId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
